import {put, select, takeEvery, throttle} from 'redux-saga/effects';
import _ from 'lodash';
import {TYPES as ROOM_TYPES} from '../creators/room';
import {removeOneFromStore, TYPES as ROOMS_TYPES} from '../creators/rooms';
import {fetchUnreadRooms} from '../creators/user.unreadRooms';
import history from "../libs/history";
import createLink from "../libs/createLink";


export const getRoom = (state) => state.room.data;
export const getRoomMedias = (state) => state.roomMedias.data;

export function* leaveSuccess(action) {
    try {
      let currentUserId = _.get(action, 'payload.currentUserId');
       let users = _.get(action, 'payload.users');
       if(users && currentUserId){
           if(!_.find(users, {_id: currentUserId})) {
               yield put(removeOneFromStore(action.payload._id));
           }
       }
    } catch (error) {

    }
}

export function* checkUnread(action) {
    try {
        //rudy j'ai ajoute une verification pour mettre a jour uniquement quand on est pas l'user du dernier message
        /*let currentUserId = _.get(action, 'payload.currentUserId');
        let lastMessageOwnerId = _.get(action, 'payload.lastMessageOwner._id');
        if(currentUserId !== lastMessageOwnerId){
            yield put(fetchUnreadRooms());
        }*/
        yield put(fetchUnreadRooms());

    } catch (error) {

    }
}

export function* updateRoomOnRTData(action) {
    try {
        let room = yield select(getRoom);
        if (room._id === action.payload._id) {
            let updated = {
                ...room,
                ...action.payload
            };
            yield put({type: ROOM_TYPES.UPDATE_SUCCESS, payload: updated});
        }
    } catch (error) {

    }
}

export function* handleCreateSuccess(action) {
    try {

        /*if(_.get(action, 'payload._id')){
            yield put({type: 'ROOMS_CREATE_STORE', payload: action.payload});
        }*/
        yield history.push(createLink("messengerRoom", {roomId: action.payload._id}));
    } catch (error) {

    }
}

export function* handleFetchError(action) {
    try {
        let statusCode =  _.get(action, "error.response.statusCode");
        if(statusCode === 404){
            yield history.push(createLink("messenger"));
        }
    } catch (error) {

    }
}


export function* watchRoom() {
    yield takeEvery(ROOM_TYPES.LEAVE_SUCCESS, leaveSuccess);
    yield takeEvery(ROOM_TYPES.CREATE_SUCCESS, handleCreateSuccess);
    yield takeEvery(ROOMS_TYPES.SUBSCRIBE_DATA, updateRoomOnRTData);
    yield throttle(1000, ROOMS_TYPES.SUBSCRIBE_DATA, checkUnread)
    yield takeEvery(ROOM_TYPES.GET_ONE_FAIL, handleFetchError);
}

export default watchRoom;

